export default "__VITE_ASSET__B1W9EwlU__"